/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Amazon EMR integration configuration
*/
export class EmrIntegrationConfig {
  'accountId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EmrIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

